import * as types from './types'
import Conseillers from '../../../services/api/conseillers';
import Users from '../../../services/api/user';

export const actions = {
	getConseillers ({ commit }) {
		return new Promise((resolve, reject) => {
			Conseillers.getConseillers()
			.then(conseillers => {
				commit(types.GET_ADVISORS, conseillers)
				resolve()
			}).catch(() => {
				reject()
			})
		})
	},
	getConseillerById ({commit}, __id) {
		return new Promise((resolve, reject) => {
      Conseillers.getConseillerById(__id).then((result) => {
        commit(types.SET_ADVISOR, result.advisor)
        commit(types.SET_CLIENTS, result.clients)
        resolve()
      }).catch(() => {
				reject()
			})
    })
	},
    addConseiller ({ commit }, __conseiller) {
        return new Promise((resolve, reject) => {
			// console.log({__conseiller})
			resolve()
			Conseillers.addConseiller(__conseiller)
			.then(conseiller => {
				// console.log(conseiller)
                commit(types.CREATE_ADVISOR, conseiller)
                resolve()
            }).catch(() => {
				reject()
			})
        })
	},
	editConseiller ({commit}, __conseiller) {
		return new Promise((resolve, reject) => {
            Conseillers.editConseiller(__conseiller).then((conseiller) => {
                commit(types.EDIT_ADVISOR, {conseiller})
                resolve()
            }).catch(() => {
				reject()
			})
        })
  },
  enableConseiller ({commit}, __id) {
		return new Promise((resolve, reject) => {
      Users.enableUser(__id)
      .then(() => {
        commit('ENABLE_ADVISOR', __id)
        resolve()
      }).catch(() => {
				reject()
			})
    })
	},
  disableConseiller ({commit}, __id) {
		return new Promise((resolve, reject) => {
      Users.disableUser(__id)
      .then(() => {
        commit('DISABLE_ADVISOR', __id)
        resolve()
      }).catch(() => {
				reject()
			})
    })
	},
  enableAdvisorClient ({commit}, __id) {
		return new Promise((resolve, reject) => {
      Users.enableUser(__id)
      .then(() => {
        commit('ENABLE_ADVISOR_CLIENT', __id)
        resolve()
      }).catch(() => {
				reject()
			})
    })
	},
  disableAdvisorClient ({commit}, __id) {
		return new Promise((resolve, reject) => {
      Users.disableUser(__id)
      .then(() => {
        commit('DISABLE_ADVISOR_CLIENT', __id)
        resolve()
      }).catch(() => {
				reject()
			})
    })
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/Conseillers/actions.js